export const APP_NAME = "AuditAI";
export const DEFAULT_LANGUAGE = "en";
export const DEFAULT_THEME = "light";
export const MOBILE_BREAKPOINT = 768;
export const SUPPORT_EMAIL = "support@{{APP_NAME}}.com";

export const PATH_TO_TITLE_MAPPING: Record<string, string> = {
  "/": "Dashboard",
  "/login": "Login",
  "/terms": "Terms",
  "/privacy": "Privacy",
  "/forgot-password": "Forgot Password",
  "*": "*",
};

export const PATH_TO_BREADCRUMB_MAPPING: Record<string, string> = {
  "/": "Dashboard",
  "/login": "Login",
  "/terms": "Terms",
  "/privacy": "Privacy",
  "/forgot-password": "Forgot Password",
  "*": "*",
};
